import { render, staticRenderFns } from "./PlacementIndexComponent.vue?vue&type=template&id=286ba9f8"
import script from "./PlacementIndexComponent.vue?vue&type=script&lang=js"
export * from "./PlacementIndexComponent.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports